var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video-player',{ref:"player",attrs:{"options":_vm.playerOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }